import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

const NavTabBillings = ({ loading, toggleTab, activeTab }) => {
  return (
    <Nav
      className="nav-tabs-custom mt-2 mb-3 ms-0 card-header-tabs border-bottom-0  "
      role="tablist"
    >
      <NavItem>
        <NavLink
          className={classnames(
            {
              active: activeTab === "current-month",
              disabled: loading,
              "fw-semibold": activeTab === "current-month",
            },
            "p-2 text-primary"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("current-month", "current");
            }
          }}
          href="#"
        >
          {" "}
          CURRENT MONTH
        </NavLink>
      </NavItem>

      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "invoices-paid",
              disabled: loading,
              "fw-semibold": activeTab === "invoices-paid",
            },
            "p-2 text-primary"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("invoices-paid", "paid");
            }
          }}
          href="#"
        >
          PAID
        </NavLink>
      </NavItem>
      <NavItem className="mx-3">
        <NavLink
          className={classnames(
            {
              active: activeTab === "invoices-due",
              disabled: loading,
              "fw-semibold": activeTab === "invoices-due",
            },
            "p-2 text-primary"
          )}
          onClick={(e) => {
            if (loading) {
              e.preventDefault();
            } else {
              toggleTab("invoices-due", "due");
            }
          }}
          href="#"
        >
          DUE
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default NavTabBillings;
